module.exports = __webpack_public_path__ + "img/avatar7.f85eadfb.png";